import { useLibrary } from '@stores/Library/Library';
import { observer } from 'mobx-react';
import { AtlasButton } from './AtlasButton';
import css from './LibraryContentHeaderRight.module.scss';

interface LibraryContentHeaderRightProps {
  /**
   * Abbreviate Atlas to its glyph. Decided and measured by the header itself
   * (`RIGHT_LABELS_BELOW` in `LibraryContent`), not here: what matters is the room the WHOLE row
   * has, and this cluster can't see that.
   *
   * This is the FIRST thing the header gives up, before the verb pills' labels. See that constant
   * for why.
   */
  compact?: boolean;
}

/**
 * The library header's right-hand side: Atlas, which leaves the library for its story map. Every
 * control that works on the media below (Add media, New folder, the search, sort, autoplay and the
 * view switch) is on the search line under the header (`LibraryToolbar`), so the header names the
 * library and offers what you can do with it as a whole.
 *
 * Empty for most users, since `AtlasButton` renders nothing unless the Story Atlas is on.
 */
export const LibraryContentHeaderRight = observer(
  ({ compact = false }: LibraryContentHeaderRightProps) => {
    const library = useLibrary();
    return (
      <div className={css.headerRight}>
        <AtlasButton libraryId={library.libraryId} compact={compact} />
      </div>
    );
  },
);
